import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbardesign from "./modeldesign/navbardesign";
import Homepage from "./pages/homepage";
import Aboutpage from "./pages/Aboutpage";
import Admindahboard from "./pages/Admindahboard";
import Testimonialspage from "./pages/Testimonialspage";
import Blogspageprocess from "./pages/Blogspage";
import Projectpostprocess from "./pages/Projectpost";
import MessageprocessContainment from "./pages/Messaageprocess";


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/admin/Testmiminials" element={<Testimonialspage />} />
        <Route path="/admin/blog" element={<Blogspageprocess />} />
        <Route path="/admin/posts" element={<Projectpostprocess />} />
        <Route path="/admin/messages" element={<MessageprocessContainment />} />
        <Route path="/admin/admindashboard" element={<Admindahboard />} />
      </Routes>
    </Router>
  );
}
